import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GenericModalData } from './generic-modal-data';

@Component({
  selector: 'generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: GenericModalData, public dialogRef: MatDialogRef<GenericModalComponent>) { }

  ngOnInit(): void {
    if (!this.data.title) { this.data.title = ''; }
    if (!this.data.question) { this.data.question = ''; }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }
}
